//Shim to only require app code once Polymer is ready, otherwise we get
//errors with react-polymer.

import 'babel-polyfill';
import i18n from './i18n';
import { loadRiotBar } from './utils/riotbar';
import { loadGeocoder } from './utils/geocoder';

const polymerReady = new Promise((resolve) => {
  window.addEventListener('WebComponentsReady', resolve);
});

Promise.all([polymerReady, i18n.loadTranslation(), i18n.loadFooter(), loadRiotBar(i18n.currentLocale()), loadGeocoder(i18n.currentLanguage())]).then(() => {
	document.title = i18n.t('meta.title')
	document.documentElement.setAttribute('lang', i18n.currentLanguage());
  const meta = document.createElement('meta')
  meta.name = 'description'
  meta.content = i18n.t('meta.description')
  document.getElementsByTagName('head')[0].appendChild(meta)
  require('./start').default();
});



// WEBPACK FOOTER //
// ./src/index.js